import { render, staticRenderFns } from "./DashboardRegistrations.vue?vue&type=template&id=b9ac9636&scoped=true"
import script from "./DashboardRegistrations.vue?vue&type=script&lang=js"
export * from "./DashboardRegistrations.vue?vue&type=script&lang=js"
import style0 from "./DashboardRegistrations.vue?vue&type=style&index=0&id=b9ac9636&prod&scoped=true&lang=css"
import style1 from "./DashboardRegistrations.vue?vue&type=style&index=1&id=b9ac9636&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ac9636",
  null
  
)

export default component.exports